module.exports = __webpack_public_path__ + "static/media/5.2b078747.JPG";